import { render, staticRenderFns } from "./PresetDialog.vue?vue&type=template&id=427f5175&"
import script from "./PresetDialog.vue?vue&type=script&lang=ts&"
export * from "./PresetDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports